module.exports = __webpack_public_path__ + "static/img/myprosegurapp.94a28429.svg";